import { render, staticRenderFns } from "./DevreKesiciDialog.vue?vue&type=template&id=5633f077&scoped=true"
import script from "./DevreKesiciDialog.vue?vue&type=script&lang=ts"
export * from "./DevreKesiciDialog.vue?vue&type=script&lang=ts"
import style0 from "./DevreKesiciDialog.vue?vue&type=style&index=0&id=5633f077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633f077",
  null
  
)

export default component.exports